import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@shared/services/auth/auth.service';

@Component({
    selector: 'app-lateral-bar',
    imports: [RouterModule, CommonModule],
    templateUrl: './lateral-bar.component.html',
    styleUrl: './lateral-bar.component.scss'
})
export class LateralBarComponent {
  private authService = inject(AuthService);

  currentMenuItem: MenuItem = MENU_ITEMS[0]
  MENU_ITEMS = MENU_ITEMS;

  constructor(
    private router: Router
  ){}

  clickedMenu(menuItem: MenuItem) {
    this.currentMenuItem = menuItem;
    this.router.navigate(menuItem.route);
  }

  logout() {
    this.authService.logout();
  }
}
const MENU_ITEMS: MenuItem[] = [{
  label: 'Usuarios',
  route: ['users'],
  icon: '/assets/icons/groups.svg',
}, {
  label: 'CMS',
  route: ['cms'],
  icon: '/assets/icons/cms.svg',
}]

interface MenuItem {
  label: string;
  route: string[];
  icon: string;
}
